// Example of SVG converted to js array, so it can be used with CIcon.
// the first argument is two last values of svg viewBox,
// the second argument is the SVG content stripped of SVG tags
export const pages = ['18 14', `
  <g>
  <path d="M1.50001 1.03334H16.5C16.5717 1.03334 16.6333 1.09494 16.6333 1.16668V12.8333C16.6333 12.9051 16.5717 12.9667 16.5 12.9667H1.50001C1.42827 12.9667 1.36667 12.9051 1.36667 12.8333V1.16668C1.36667 1.09494 1.42827 1.03334 1.50001 1.03334Z" stroke="var(--active-svg-stroke-color, #C2CFE0)" stroke-width="1.4"/>
  <rect x="5.5" y="0.333344" width="1.16667" height="13.3333" fill="var(--active-svg-stroke-color, #C2CFE0)"/>
  <rect x="11.3333" y="0.333344" width="1.16667" height="13.3333" fill="var(--active-svg-stroke-color, #C2CFE0)"/>
  </g>
`]
